"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlayer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _video = _interopRequireDefault(require("video.js"));
require("video.js/dist/video-js.css");
require("./style.css");
/* istanbul ignore file */

class VideoPlayer extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      audioText: ''
    };
  }
  componentDidMount() {
    // instantiate Video.js
    const props = this.props;
    if (this.videoNode) {
      this.player = (0, _video.default)(this.videoNode, this.props);
      this.player.ready(() => {
        props.onVideoReady(this.player);
        window.player = this.player;
      });
      this.player.on('play', () => {
        props.onVideoPlay(this.player.currentTime());
      });
      this.player.on('pause', () => {
        props.onVideoPause(this.player.currentTime());
      });
      this.player.on('ended', () => {
        props.onVideoEnd();
      });
      this.player.on('error', error => {
        if (this.player.errorDisplay.el().childNodes[1].innerHTML) {
          this.player.errorDisplay.el().childNodes[1].innerHTML = `${this.player.errorDisplay.el().childNodes[1].innerText} Contact <a href="mailto:help@placeexchange.com" target="_top"> help@placeexchange.com </a> if you have any questions.`;
        }
        this.setState({
          audioText: ''
        });
        props.onVideoError(error);
      });
      this.player.on('loadedmetadata', () => {
        if (this.props.hasAudio) this.setState({
          audioText: 'Audio Available'
        });else this.setState({
          audioText: 'Audio Not Available'
        });
        props.onVideoMetadata();
      });
    }
  }
  componentDidUpdate(prevProps) {
    const {
      changeVideoSrc
    } = this.props;
    if (changeVideoSrc && prevProps.changeVideoSrc !== changeVideoSrc) {
      this.player.src(changeVideoSrc);
    }
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    const {
      audioText
    } = this.state;
    const {
      showAudioTitle
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", null, showAudioTitle && audioText && /*#__PURE__*/_react.default.createElement("div", {
      className: "audio--title"
    }, audioText), /*#__PURE__*/_react.default.createElement("div", {
      "data-vjs-player": true
    }, /*#__PURE__*/_react.default.createElement("video", {
      "aria-label": "video_player",
      id: "VideoPlayer",
      ref: node => this.videoNode = node,
      className: "video-js vjs-big-play-centered vjs-px"
    })));
  }
}
exports.VideoPlayer = VideoPlayer;
VideoPlayer.defaultProps = {
  onVideoReady: () => {},
  onVideoPlay: () => {},
  onVideoPause: () => {},
  onVideoEnd: () => {},
  onVideoError: () => {},
  onVideoMetadata: () => {},
  changeVideoSrc: "",
  autoplay: false,
  controls: true,
  loop: false,
  poster: '',
  fluid: false,
  showAudioTitle: false,
  hasAudio: false,
  muted: false
};
VideoPlayer.propTypes = {
  /** An array of objects that mirror the native `<video>` element's capability to have a series of child <source> elements. 
   * This should be an array of objects with the src and type properties. 
   */
  sources: _propTypes.default.arrayOf(_propTypes.default.shape({
    src: _propTypes.default.string.isRequired,
    type: _propTypes.default.string.isRequired
  })).isRequired,
  autoplay: _propTypes.default.bool,
  /** Determines whether or not the player has controls that the user can interact with. Without controls the only way to start the video playing is with the autoplay attribute or through the Player API. */
  controls: _propTypes.default.bool,
  /** Causes the video to start over as soon as it ends. */
  loop: _propTypes.default.bool,
  /** A URL to an image that displays before the video begins playing. This is often a frame of the video or a custom title screen. As soon as the user hits "play" the image will go away. */
  poster: _propTypes.default.string,
  /** Puts the player in fluid mode and the value is used when calculating the dynamic size of the player. The value should represent a ratio - two numbers separated by a colon (e.g. "16:9" or "4:3"). */
  aspectRatio: _propTypes.default.string,
  /** When `true`, the player will have a fluid size. In other words, it will scale to fit its container. */
  fluid: _propTypes.default.bool,
  /** Allows overriding the default message that is displayed when Video.js cannot play back a media source. */
  notSupportedMessage: _propTypes.default.string,
  /** Puts the player in fluid mode and the value is used when calculating the dynamic size of the player. The value should represent a ratio - two numbers separated by a colon (e.g. "16:9" or "4:3"). */
  aspectRatio: _propTypes.default.string,
  /** Decide whether to show audio title or not */
  showAudioTitle: _propTypes.default.bool,
  /** Display `Audio Available` OR `Audio Not Available` title */
  hasAudio: _propTypes.default.bool,
  /** Will silence any audio by default.*/
  muted: _propTypes.default.bool,
  onVideoReady: _propTypes.default.func,
  onVideoPlay: _propTypes.default.func,
  onVideoPause: _propTypes.default.func,
  onVideoEnd: _propTypes.default.func
};